import api from '../../lib/api'

const taskService = {
  // --- Task Lists ---
  getMyAssignedTasks(params = {}) {
    return api.get('/api/hr/my-assigned-tasks/', { params })
  },

  getMyGeneralTasks(params = {}) {
    return api.get('/api/hr/mygeneraltasks/', { params })
  },

  // --- Single Task ---
  getTaskById(id) {
    return api.get(`/api/hr/membertask/${id}/`)
  },

  // --- Task Actions ---
  acceptTask(id) {
    return api.put(`/api/hr/accept-task/${id}/`)
  },

  refuseTask(id, comment) {
    return api.put(`/api/hr/refuse-task/${id}/`, { comment })
  },

  completeTask(id) {
    return api.put(`/api/hr/complete-task/${id}/`)
  },

  completeTaskPartially(id) {
    return api.put(`/api/hr/complete-task-partially/${id}/`)
  },

  setTaskSeen(membertaskId) {
    return api.post('/api/hr/tasksetseen/', { membertask_id: membertaskId })
  },

  // --- Comments ---
  getComments(membertaskId) {
    return api.get('/api/hr/membertaskcomment/', {
      params: { membertask_id: membertaskId },
    })
  },

  addComment(membertaskId, comment, files = []) {
    const formData = new FormData()
    formData.append('membertask_id', membertaskId)
    formData.append('comment', comment)
    files.forEach((file) => formData.append('docs[]', file))
    return api.post('/api/hr/membertaskcomment/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  deleteComment(id) {
    return api.delete(`/api/hr/membertaskcomment/${id}/`)
  },

  // --- Documents ---
  getDocs(membertaskId) {
    return api.get('/api/hr/membertask-docs/', {
      params: { member_task: membertaskId },
    })
  },

  addDoc(membertaskId, file, description = '') {
    const formData = new FormData()
    formData.append('membertask_id', membertaskId)
    formData.append('doc_file', file)
    if (description) formData.append('description', description)
    return api.post('/api/hr/membertaskdoc/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  deleteDoc(id) {
    return api.delete(`/api/hr/membertaskdoc/${id}/`)
  },

  // --- Reports ---
  createReport(data) {
    const formData = new FormData()
    formData.append('membertask_id', data.membertask_id)
    formData.append('os_id', data.os_id)
    formData.append('meeting_date', data.meeting_date)
    if (data.participants_count != null) formData.append('participants_count', data.participants_count)
    if (data.males_count != null) formData.append('males_count', data.males_count)
    if (data.females_count != null) formData.append('females_count', data.females_count)
    if (data.youngs_count != null) formData.append('youngs_count', data.youngs_count)
    if (data.free_professions_count != null) formData.append('free_professions_count', data.free_professions_count)
    if (data.new_members_count != null) formData.append('new_members_count', data.new_members_count)
    if (data.new_members_names) formData.append('new_members_names', data.new_members_names)
    if (data.headers_names) formData.append('headers_names', data.headers_names)
    if (data.proposed_delegate_name) formData.append('proposed_delegate_name', data.proposed_delegate_name)
    if (data.comment) formData.append('comment', data.comment)
    if (data.video) formData.append('video', data.video)
    if (data.images && data.images.length) {
      data.images.forEach((img) => formData.append('images_list', img))
    }
    return api.post('/api/hr/report-membertask/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  getReports(membertaskId) {
    return api.get(`/api/hr/membertask-reports/${membertaskId}/`)
  },

  getReportDetails(id) {
    return api.get(`/api/hr/membertask-report-info/${id}/`)
  },

  deleteReport(id) {
    return api.delete(`/api/hr/delete-task-report/${id}/`)
  },

  // --- QR Code ---
  scanQrCode(qrCode) {
    return api.post('/api/hr/membertask/qrcode/', { qr_code: qrCode })
  },

  getQrTasks() {
    return api.get('/api/hr/task/qrcodeunique/')
  },
}

export default taskService
